/**
 * Clone this to config.js and set appropriate values
 */
export default {
  paymentcloud: {
    STRATUS_URL: 'https://stratusapp.io/',
    MAIN_URL: 'https://apply.paymentcloudinc.com/',
    APPLICATION_URL: 'https://application.stratusapp.io/',
    PUSHER_KEY: 'b690f383eba5a60ad282',
    PUSHER_CLUSTER: 'us2',
    RESIDUAL_SYSTEM: [272, 1, 2, 1197, 1313],
    GOOGLE_CAPTCHA: '6LeWXeUcAAAAAKUvn0P9aZwZJL4opHTdGzmWCZbX',
    HIDE_APPLICATION_USER_ID: 1460,
    ENABLE_ESIGN_ON_ROUTE: ["mwright", "an", "nhamou", "adelzer", "asethh", "msaad", "s-", "aamatelli", "cnightingle", "efoden", "aalsayedi", "application", "cflores", "wdetterman", "lsupport", "jpalacios", "mfocus", "sschiffer", "lhe", "jneumann", "cneumann", "gbehling", "hlinse", "jneumann1"],
    EMS_ORG_ID: 1207,
    PAYCHEX_ORG_ID: 1406,
    PAYMENTCLOUD_ORG_ID: 1,
    GOOGLE_API_KEY: "AIzaSyC1vqtDNH2r2YdwppicGtcQtN64jNhxaOk",
    KURVPAY_ORG_ID : 1485,
    HOUSE_RISK_ORG_ID : 1514,
    KURV_PROCESSOR_ID: 39,
    KURV_MERCHANT_EQUIPMENT_ID: 128,
    DASHBOARD_ALLOWED_ORG_IDS: [1559,1567,1429,1502,1585],
    PLATINUM_SERVICE_CLUB_EQUIPMENT_ID: 34,
    ACH_PROCESSOR_IDS: [35],
    SKIP_PRICING_MINIMUM_PROCESSOR_IDS: [16],
  },
};
